import { render } from "./PdfFileUpload.vue?vue&type=template&id=67a1bb62&scoped=true"
import script from "./PdfFileUpload.vue?vue&type=script&lang=js"
export * from "./PdfFileUpload.vue?vue&type=script&lang=js"

import "./PdfFileUpload.vue?vue&type=style&index=0&id=67a1bb62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a1bb62"]])

export default __exports__